import { useEffect, useState } from 'react';
import { listPublishedCourses } from '../lib/api';
import { friendlyError } from '../lib/supabase';
import type { Course } from '../lib/types';
import { CourseCard } from '../components/CourseCard';
import { Callout, SectionTitle, Spinner } from '../components/ui';

export function Catalog() {
  const [courses, setCourses] = useState<Course[] | null>(null);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => { listPublishedCourses().then(setCourses).catch((e) => setError(friendlyError(e))); }, []);

  return (
    <>
      <section className="title-band">
        <div className="container title-band-inner">
          <div><SectionTitle overline="Course catalog" subtitle="Practical delineation and permitting training for California environmental professionals.">Courses</SectionTitle></div>
        </div>
      </section>
      <div className="container page">
        {error && <Callout variant="error">{error}</Callout>}
        {!courses && !error && <Spinner />}
        {courses && (courses.length ? (
          <div className="cards-grid">{courses.map((c) => <CourseCard key={c.id} course={c} />)}</div>
        ) : <div className="empty">New courses are on the way.</div>)}
      </div>
    </>
  );
}
